var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useCallback, useMemo } from 'react';
import { DATA_CACHE_LOCATION, DATA_CACHE_SIZE, FILE_LOCKING_EXTENSIONS, FORBID_SPECIAL_CHARACTERS, MAX_DOWNLOAD_RATE, MAX_UPLOAD_RATE, MOUNT_POINT_LINUX, MOUNT_POINT_OSX, MOUNT_POINT_WINDOWS, TEAM_CACHE_ENABLED, TEAM_CACHE_LOCATION, } from '@lucidlink/sdk';
import { translate, useToastService } from '@lucidlink/uicore';
const settingNameToHumanReadableMap = () => ({
    [DATA_CACHE_SIZE]: translate('cache size'),
    [DATA_CACHE_LOCATION]: translate('Cache location'),
    [FILE_LOCKING_EXTENSIONS]: translate('file locking extensions'),
    [FORBID_SPECIAL_CHARACTERS]: translate('Allow special characters'),
    [MOUNT_POINT_LINUX]: translate('Linux mount point'),
    [MOUNT_POINT_OSX]: translate('macOS mount point'),
    [MOUNT_POINT_WINDOWS]: translate('Windows mount point'),
    [MAX_DOWNLOAD_RATE]: translate('Max download rate'),
    [MAX_UPLOAD_RATE]: translate('Max upload rate'),
    [TEAM_CACHE_LOCATION]: translate('TeamCache server location'),
    [TEAM_CACHE_ENABLED]: translate('TeamCache enabled'),
});
export const useFilespaceSettingsToasts = ({ settingName, }) => {
    _react_refresh_temp_1();
    // add which settings have been applied
    const settingTranslationMap = useMemo(() => settingNameToHumanReadableMap(), []);
    const { addToast } = useToastService();
    const handleToasts = useCallback(({ isReset } = {}) => {
        if (!isReset) {
            addToast({
                'data-testid': 'filespace-setting-update-success',
                kind: 'positive',
                content: {
                    message: translate('Default {{setting}} updated successfully.', {
                        setting: settingTranslationMap[settingName],
                    }),
                },
            });
        }
        else {
            addToast({
                'data-testid': 'filespace-setting-reset-success',
                kind: 'positive',
                content: {
                    message: translate('Default {{setting}} reset successful.', {
                        setting: settingTranslationMap[settingName],
                    }),
                },
            });
        }
    }, [addToast, settingName, settingTranslationMap]);
    return { handleToasts };
};
_react_refresh_temp_1(useFilespaceSettingsToasts, "yfegEv2fMrWIT5nsIrMc4LibdWU=", false, () => [useToastService]);
